module.exports = __webpack_public_path__ + "img/domain-icon.c42ea691.svg";